"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersection = exports.deArray = exports.generateClassString = exports.range = exports.playerColorClass = void 0;
const playerColorClass = (color, type) => {
    const prefix = {
        shadow: 'player_shadow_color_',
        bg_transparent: 'player_translucent_bg_color_',
        bg: 'player_bg_color_',
    }[type];
    return `${prefix}${color}`;
};
exports.playerColorClass = playerColorClass;
const range = (n) => Array.from(Array(n).keys());
exports.range = range;
const generateClassString = (classes) => classes.join(' ').trimStart();
exports.generateClassString = generateClassString;
function deArray(input) {
    if (!Array.isArray(input)) {
        return input;
    }
    if (input.length > 0) {
        return input[0];
    }
    return undefined;
}
exports.deArray = deArray;
function intersection(a, b) {
    return a.filter((e) => b.includes(e));
}
exports.intersection = intersection;
//# sourceMappingURL=utils.js.map